import styled, { css } from 'styled-components';

export const Content = styled.div`
  color: #000;
  .popup {
    top: 39px;
    box-shadow: none;
    background-color: #fff;
    /* box-shadow: 0 1px 2px 2px rgba(85, 85, 85, 0.2); */
    border: solid 1px #bebebe;
  }
  .checkbox {
    label {
      color: #000;
    }
    input {
      border: solid 1px #bebebe;
      padding: 0;
    }
  }
  .input {
    padding: 0 9px;
  }

  &:before {
    display: none;
  }
  &.width-auto {
    .popup {
      width: 100%;
    }
  }
`;

export const InputBox = styled.div`
  height: 40px;
  background-color: #fff;
  cursor: pointer;
  position: relative;
  &.input {
    padding-right: 30px;
  }
  &:after {
    /* z-index: 1; */
    content: '';
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -6px;
    width: 6px;
    height: 6px;
    border: 2px solid #6e7a86;
    border-width: 0 2px 2px 0;
    transform-origin: center;
    transform: rotate(45deg);
    transition: all 0.15s ease-in;
  }
  ${(props) =>
    props.$popupIsOpen &&
    css`
      &:after {
        margin-top: -3px;
        transform: rotate(225deg);
      }
    `}
`;

export const Popup = styled.div`
  position: absolute;
  z-index: 11;
  padding: 15px;
  box-shadow: none;
  max-width: none;
  /* width: 100%; */
  border-radius: 4px;
  top: 42px;
  left: 0;
  max-height: 240px;
  overflow-y: auto;
  display: ${(props) => (props.$popupIsOpen ? 'block' : 'none')};
  min-width: ${(props) => props.minWidth ?? 'none'};
`;
